<template>
	<b-card class="shadow" style="min-height: 700px" id="printme">
		<div class="row">
			<div class="col-12" v-if="!loading">
				<div class="d-flex align-items-center justify-content-between mb-4">
					<h5 class="mb-0 text-gray-800">
						{{ $t("Concessões de Benefícios") }}
					</h5>
					<b-button-group>
						<b-button
							variant="outline-dark"
							:class="viewFilterReport === true ? 'active' : ''"
							@click="viewFilters"
						>
							<i class="fas fa-filter"></i>
							{{ $t("Filtros") }}
						</b-button>
						<b-button
							variant="outline-dark"
							:class="range === 'weekly' ? 'active' : ''"
							@click="updateAnalytics('weekly')"
						>
							<i class="fas fa-calendar-week"></i>
							{{ $t("Weekly") }}
						</b-button>
						<b-button
							variant="outline-dark"
							:class="range === 'monthly' ? 'active' : ''"
							@click="updateAnalytics('monthly')"
						>
							<i class="fas fa-calendar-alt"></i>
							{{ $t("Monthly") }}
						</b-button>
						<b-button
							variant="outline-dark"
							:class="range === 'yearly' ? 'active' : ''"
							@click="updateAnalytics('yearly')"
						>
							<i class="fas fa-calendar"></i>
							{{ $t("Yearly") }}
						</b-button>
					</b-button-group>
				</div>
			</div>
			<div class="col-12" v-if="viewFilterReport">
				<!-- Filtros -->
				<form @submit.prevent="getAnalytics" ref="addItem">
					<div class="row">
						<form-select
							v-model="filtros.unidade"
							label="Filtrar por Unidade"
							grid="6"
							:itens="unidades"
							:disabled="desabledSearchUnidade"
							:loading="loadingSearchUnidade"
							@input="getTecnicos"
						/>

						<form-select
							v-model="filtros.tecnico"
							grid="6"
							label="Filtrar por Técnico Responsável"
							:itens="listtecnicos"
							:disabled="desabledSearchTecnicos"
							:loading="loadingSearchTecnicos"
							placeholder="Selecione uma Unidade antes"
						/>

						<form-select
							v-model="filtros.tipo"
							label="Filtrar por Tipo"
							grid="6"
							:itens="tipos"
							:disabled="loadingSearchTipos"
							:loading="loadingSearchTipos"
						/>

						<form-calendar 
							v-model="data_inicio" 
							grid="3" 
							label="Data de início" 
							:maxDate="data_fim || null"
						/>

						<form-calendar
							v-model="data_fim"
							grid="3"
							label="Data Final"
							:required="verificaDataInicial"
							:minDate="data_inicio || null"
						/>

						<form-select
							v-model="filtros.status_parecer"
							grid="6"
							label="Status do Parecer"
							:itens="$root.arrays.status_parecer"
						/>

						<form-select
							v-model="filtros.status_liberacao"
							grid="6"
							label="Status da Concessão"
							:itens="$root.arrays.status_liberacao"
						/>

						<div class="col-md-6">
							<label for="input-search">
								<b>Pesquisar por Nome de Usuário</b>
							</label>
							<b-input
							placeholder="Digite o nome Nome de Usuário e clique em Gerar Relatório "
							class="form-control search-input"
							type="text"
							v-model="search"
							/>
						</div>

						<form-calendar 
							v-model="data_inicio_concessao" 
							grid="3" 
							label="Data de início da concessão" 
							:maxDate="data_fim_concessao || null"
						/>

						<form-calendar
							v-model="data_fim_concessao"
							grid="3"
							label="Data Final da concessão"
							:minDate="data_inicio_concessao || null"
						/>

						<div class="col-md-6">
							<label for="input-search">
								<b>Pesquisar por Nome de Benefício</b>
							</label>
							<b-input
							placeholder="Digite o nome Nome do Benefício e clique em Gerar Relatório "
							class="form-control search-input"
							type="text"
							v-model="search_beneficio"
							/>
						</div>

						<form-calendar 
							v-model="data_inicio_entrega" 
							grid="3" 
							label="Data de início da entrega"
							:maxDate="data_fim_entrega || null" 
						/>

						<form-calendar
							v-model="data_fim_entrega"
							grid="3"
							label="Data Final da entrega"
							:minDate="data_inicio_entrega || null"
						/>
					</div>
					<div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
						<div class="col-auto px-2 text-right">
							<button class="btn btn-default" @click="viewFilters">
								<i class="fas fa-times"></i>
							</button>

							<button type="button" class="btn btn-secondary" @click.prevent="limparFiltros">
								{{ $t("Limpar Filtros") }}
							</button>
							<button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
								<i class="fas fa-chart-bar"></i>
								{{ $t("Gerar Relatório") }}
							</button>
						</div>
					</div>
				</form>
			</div>
			<loading-report
				:loading="isLoadingMsg"
				mensagem="Por favor aguarde estamos realizando sua solicitação..."
				icone="fa-smile-wink"
			></loading-report>
			<load v-if="loading" mode="table" />
			<div v-else class="col-md-12">
				<!-- <loading-animation
					:active.sync="loading"
					:is-full-page="false"
					:opacity="1"
					color="#5895FF"
				/> -->
				<print-content>
					<template v-slot:datas>
						<p v-if="datas.start">
							Período de pesquisa selecionado:
							<b>{{ datas.start }} - {{ datas.end }}</b>
							<b-link
								href="#"
								@click.prevent="void 0"
								class="mb-2"
								variant="info"
								v-b-popover.hover.top="
									'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
								"
							>
								<i class="fas fa-info-circle"></i>
							</b-link>
						</p>
					</template>
					<b-table
						:fields="[
							{
								key: 'protocolo',
								label: $t('Detalhes'),
							},
							{
								key: 'cadastrado',
								label: $t('Cadastrado'),
							},
							{
								key: 'status_nome',
								label: $t('Status'),
							},
							{
								key: 'actions',
								label: '',
								class: 'text-right no-print',
								thStyle: { width: '95px', minWidth: '95px' },
							},
						]"
						:items="ItemList"
						:responsive="true"
						striped
						hover
						show-empty
						small
						outlined
						stacked="xs"
						table-class="mb-3"
					>
						<template v-slot:cell(protocolo)="data">
							<i class="mdi mdi-lock mdi-18px text-danger" v-if="data.item.privado == 1"></i>
							<strong>{{ data.item.usuario.nome_completo }}</strong
							><br />
							Protocolo: <b>{{ data.item.protocolo }}</b>
							<br />
							Nome do beneficio:
							<b>{{ data.item.beneficio.nome }}</b
							><br />
							Tipo:
							<b>{{ data.item.beneficio.tipo ? data.item.beneficio.tipo.descricao : "" }}</b
							><br />
							Técnico:<b>{{ data.item.responsavel ? data.item.responsavel.name : "" }}</b>
							<br />
							Unidade:
							<b>{{ data.item.beneficio.unidade.nome }}</b>
						</template>

						<template v-slot:cell(cadastrado)="data">
							{{ data.item.cadastrado }}
						</template>
						<template v-slot:cell(status_nome)="data">
							<small class="text-muted text-xs">Status da Concessão: </small>
							<span class="small" v-html="data.item.status_nome"></span>
							<br />
							<small class="text-muted text-xs">Status do Parecer:</small>
							<span
								class="small text-muted"
								v-if="
									data.item.status_nome == 'AGUARDANDO VISITA TÉCNICA' ||
									data.item.status_parecer == 4
								"
								>VISITA TÉCNICA REALIZADA</span
							>
							<span v-else v-html="data.item.status_parecer_nome"></span>
							<small class="text-muted" v-if="data.item.atualizado"
								><br />{{ data.item.atualizado }}</small
							>
						</template>
						<template v-slot:cell()="data">
							<button
								@click.prevent="redirectBeneficio(data.item.id, data.item.familia_id)"
								class="px-2 mb-0 btn btn-sm btn-success"
							>
								<i class="mdi mdi-square-edit-outline" />
							</button>
						</template>
						<template v-slot:empty="scope">
							<div class="text-center my-5">
								<img
									:alt="$t('No results')"
									class="mb-5"
									src="/img/icons/robot.svg"
									style="max-height: 165px"
								/>
								<h3 class="bold">
									{{ $t("No records found") }}
								</h3>
							</div>
						</template>
					</b-table>
				</print-content>
				<div class="row align-items-center no-print">
					<div class="col-lg-6 col-md-12">
						<div class="form-group d-inline-flex mb-0">
							<select
								class="form-control"
								style="width: 70px"
								v-model="perPage"
								v-on:change="getAnalytics"
							>
								<option value="5">5</option>
								<option value="10">10</option>
								<option value="25">25</option>
								<option value="50">50</option>
							</select>
						</div>
						<div class="d-inline-flex ml-2">
							<b-pagination
								:per-page="perPage"
								:total-rows="pagination.total"
								@change="changePage"
								v-model="page"
							/>
						</div>
					</div>
					<div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
						<div class="float-lg-right">
							{{ $t("Showing page") }}
							{{ pagination.currentPage }} {{ $t("of") }}
							{{ pagination.totalPages }}
							{{ $t("pages in") }}
							{{ pagination.total }}
							{{ $t("records") }}
						</div>
					</div>
				</div>
				<div class="row no-print mt-4">
					<div class="col-lg-12 col-md-12 text-center align-items-center">
						<b-button
							:title="$t('Visualizar e Imprimir')"
							class="py-2"
							size="sm"
							type="button"
							v-b-tooltip.hover
							variant="primary"
							@click="print()"
						>
							<i class="fas fa-print"></i>
						</b-button>
					</div>
				</div>
			</div>
		</div>
	</b-card>
</template>

<script>
export default {
	name: "ConcessoesReports",
	data() {
		return {
			loading: true,
			loadingSearchUnidade: true,
			desabledSearchUnidade: true,
			loadingSearchTecnicos: false,
			desabledSearchTecnicos: true,
			loadingSearchTipos: true,
			range: "yearly",
			ItemList: [],
			unidades: [],
			page: 1,
			search: "",
			search_beneficio: "",
			perPage: 10,
			pagination: {
				currentPage: 0,
				perPage: 0,
				total: 0,
				totalPages: 0,
			},
			filtros: {},
			tecnicos: [],
			tipos: [],
			subtipos: [],
			data_inicio: "",
			data_fim: "",
			isLoadingMsg: false,
			user_id: null,
			tecnico_id: null,
			unidade_id: null,
			role: null,
			datas: [],
			data_inicio_concessao: "",
			data_fim_concessao: "",
			data_inicio_entrega: "",
			data_fim_entrega: "",
		};
	},
	mounted() {
		this.getTipos();
		this.getUnidades();
		this.getAnalytics();
	},
	created() {
		this.min = 0;
		this.max = 100;
		this.enableCross = false;
	},
	computed: {
		listtecnicos() {
			const pessoas = this.tecnicos;

			const map = pessoas.map((elem) => ({
				id: elem.id,
				value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
			}));
			return map;
		},
	},
	methods: {
		filterData(value) {
			return this.$options.filters.formatDateHora(value);
		},
		updateAnalytics(range) {
			if (this.range !== range) {
				this.range = range;
				this.getAnalytics();
			}
		},
		changePage(page) {
			if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
				this.page = page;
				this.getAnalytics();
			}
		},
		getAnalytics() {
			this.isLoadingMsg = true;
			this.loading = true;

			if (this.data_inicio) {
				this.filtros.data_inicial = this.$options.filters.formatDateYMD(
					this.data_inicio
				);
			}
			if (this.data_fim) {
				this.filtros.data_final = this.$options.filters.formatDateYMD(this.data_fim);
			}

			if (this.data_inicio_entrega) {
				this.filtros.data_inicio_entrega = this.$options.filters.formatDateYMD(
					this.data_inicio_entrega
				);
			}

			if (this.data_fim_entrega) {
				this.filtros.data_fim_entrega = this.$options.filters.formatDateYMD(
					this.data_fim_entrega
				);
			}

			if (this.data_inicio_concessao) {
				this.filtros.data_inicio_concessao = this.$options.filters.formatDateYMD(
					this.data_inicio_concessao
				);
			}

			if (this.data_fim_concessao) {
				this.filtros.data_fim_concessao = this.$options.filters.formatDateYMD(
					this.data_fim_concessao
				);
			}

			axios
				.get("api/dashboard/report/beneficios/concessoes", {
					params: {
						page: this.page,
						search: this.search,
						beneficio: this.search_beneficio,
						perPage: this.perPage,
						range: this.range,
						filtros: this.filtros,
					},
				})
				.then((response) => {
					this.loading = false;

					this.user_id = this.$store.state.user.id;
					this.tecnico_id = this.$store.state.user.tecnico.id;
					this.unidade_id = this.$store.state.unidade;
					this.role = this.$store.state.user.role;
					this.datas = response.data.datas;
					this.ItemList = response.data.dados.original.data;
					this.pagination = response.data.dados.original.pagination;
					this.filtros["unidade"] = null;
					if (this.pagination.totalPages < this.pagination.currentPage) {
						this.page = this.pagination.totalPages;
						this.getAnalytics();
					} else {
						this.isLoadingMsg = false;
						this.loading = false;
					}
				})
				.catch(() => {
					this.isLoadingMsg = false;
					this.loading = false;
				});
		},
		getUnidades() {
			this.loadingSearchUnidade = true;
			this.desabledSearchUnidade = true;
			axios
				.get(`api/dashboard/unidades/get/externas`)
				.then((response) => {
					this.unidades = response.data;
				})
				.finally(() => {
					this.loadingSearchUnidade = false;
					this.desabledSearchUnidade = false;
				});
		},
		getTecnicos() {
			this.loadingSearchTecnicos = true;
			this.desabledSearchTecnicos = false;
			axios
				.get(`api/dashboard/atendimento/tecnicos/get?unidade=${this.filtros.unidade}`)
				.then((response) => {
					this.tecnicos = response.data;
				})
				.finally(() => {
					this.loadingSearchTecnicos = false;
					this.desabledSearchTecnicos = false;
				});
		},
		getTipos() {
			this.loadingSearchTipos = true;
			axios
				.get(`api/dashboard/report/get/beneficios/tipos`)
				.then((response) => {
					this.tipos = response.data;
				})
				.finally(() => (this.loadingSearchTipos = false));
		},
		getSubTipos() {
			this.loadSubtipo = true;
			this.subtipos = [];
			axios
				.get(`api/dashboard/report/get/beneficios/subtipos/${this.tipo}`)
				.then((response) => {
					this.subtipos = response.data;
				})
				.finally(() => {
					this.loadSubtipo = false;
				});
		},
		redirectBeneficio(id, familia_id) {
			let routeData = this.$router.resolve({
				path: "/dashboard/familia/beneficio/edit/" + id,
				query: { familia_id: familia_id },
			});
			window.open(routeData.href, "_blank");
		},
		limparFiltros() {
			// this.filtros = {};
			// this.search = "";
			// this.data_inicio = "";
			// this.data_fim = "";
			// this.verificaDataInicial = false;
			Object.assign(this.$data, this.$options.data.call(this));
			this.getTipos();
			this.getUnidades();
			this.getAnalytics();
		},
	},
};
</script>
